import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const AnimationArea = styled(Box)`
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: linear-gradient(
      to bottom,
      rgba(4, 28, 27, 0.2) 15.57%,
      #041c1b 100%
    );
    @media (min-width: 1024px) {
      background: linear-gradient(
        180deg,
        rgba(4, 28, 27, 0.2) 15.57%,
        #041c1b 100%
      );
    }
  }

  &::after {
    content: "";
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
    background: rgba(4, 28, 27, 0.2);
    background: linear-gradient(
      to bottom,
      rgba(4, 28, 27, 0) 0%,
      rgba(4, 28, 27, 0.1) 50%,
      rgba(4, 28, 27, 0.2) 60%,
      #041c1b 100%
    );

    @media (min-width: 1024px) {
      background: linear-gradient(
        to left,
        rgba(4, 28, 27, 0) 0%,
        rgba(4, 28, 27, 0.1) 50%,
        rgba(4, 28, 27, 0.2) 60%,
        #041c1b 100%
      );
    }
  }
`

export const AnimationWrapper = styled(Box)`
  height: 100%;
`

export const AnimationBackground = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  will-change: filter;
`

export const AnimatedOverlay = styled(Box)`
  width: 100%;
  height: 100%;
  padding: 60px 0 50px;
  @media (min-width: 1024px) {
    padding: 30px 0 0;
  }
`

export const SlideWrapper = styled(Box)`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  will-change: opacity;
`

export const SlideTrack = styled(Box)`
  position: relative;
  z-index: 2;

  @media (min-width: 1024px) {
    top: 50%;
    transform: translateY(-50%);
  }

  .slick-list {
    position: relative;
    z-index: 3;
  }

  .slick-track {
    display: flex !important;
    position: relative;
  }
`

export const CauseText = styled(Box)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;

  @media (min-width: 1024px) {
    transform: translateX(-50%);
  }
`

export const Divider = styled.div`
  pointer-events: none;
  position: absolute;
  top: -30px;
  bottom: 0;
  width: 2px;
  margin-left: -1px;
  left: 50%;
  background: repeating-linear-gradient(
      to bottom,
      transparent 0 10px,
      rgba(255, 255, 255, 0.2) 10px 13px
    )
    80%/2px 100% no-repeat;

  z-index: 1;
`

export const Dots = styled.div`
  position: absolute;
  left: 50%;
  z-index: 5;

  transform: translate(-50%, -2px);

  @media (min-width: 768px) {
    transform: translate(-50%, 1px);
  }

  @media (min-width: 1024px) {
    transform: translate(-50%, 2px);
  }
`

export const Dot = styled(Box)`
  position: absolute;
  border-radius: 50%;
  background: ${theme.wild.color.nova.brand.accent[80]};
  bottom: 0;
  transform: translateX(-50%);

  width: 6px;
  height: 6px;

  @media (min-width: 768px) {
    width: 8px;
    height: 8px;
  }

  @media (min-width: 1024px) {
    width: 10px;
    height: 10px;
  }
`

export const Slide = styled(Box)`
  position: relative;
  z-index: 3;
`
